import Vue from 'vue'

// Styles
import './css/normalize.min.css'
import './css/seriousmd-icons.css'
import '../../node_modules/@material/linear-progress/dist/mdc.linear-progress.min.css'

import './scss/pogs-application.scss'
import './scss/smd-concrete-layout.scss'

// Components
import oneColumnLayout from './_one-column-layout'
import twoColumnLayout from './_two-column-layout'
import smdOptions      from './smd-options'
import smdNavigation   from './smd-navigation'
import smdTitleBar     from './smd-titlebar'
import smdButton       from './smd-button'
import smdAileron      from './smd-aileron'
import smdCheckbox     from './smd-checkbox'
import smdCheckboxList from './smd-full-checkbox-list'
import smdSegment      from './smd-segment'
import smdDateInput    from './smd-date-input.vue'
import smdLoadingDots  from './smd-loading-dots.vue'
import smdSelect       from './smd-select'

Vue.component('one-column-layout'          , oneColumnLayout);
Vue.component('two-column-layout'          , twoColumnLayout);
Vue.component('smd-options'                , smdOptions);
Vue.component('smd-navigation'             , smdNavigation);
Vue.component('title-bar'                  , smdTitleBar);
Vue.component('smd-btn'                    , smdButton);
Vue.component('smd-aileron'                , smdAileron);
Vue.component('smd-checkbox'               , smdCheckbox);
Vue.component('smd-segment'                , smdSegment);
Vue.component('smd-full-checkbox-list'     , smdCheckboxList);
Vue.component('smd-date-input'             , smdDateInput);
Vue.component('smd-loading-dots'           , smdLoadingDots);
Vue.component('smd-select'                 , smdSelect);
